/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_LabelInputs */

const en_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative application overview`)
};

const de_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beispielhafte Bewerbungsübersicht`)
};

const fr_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue d’ensemble illustrative des candidatures`)
};

const es_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen ilustrativo de solicitudes`)
};

const it_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica illustrativa delle candidature`)
};

const nl_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustratief sollicitatieoverzicht`)
};

const pl_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przykładowy przegląd aplikacji`)
};

const fi_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havainnollistava hakemusyleiskatsaus`)
};

const da_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrativ ansøgningsoversigt`)
};

const sv_landing_application_overview_label = /** @type {(inputs: Landing_Application_Overview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrativ ansökningsöversikt`)
};

/**
* | output |
* | --- |
* | "Illustrative application overview" |
*
* @param {Landing_Application_Overview_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_label = /** @type {((inputs?: Landing_Application_Overview_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_label(inputs)
	if (locale === "fr") return fr_landing_application_overview_label(inputs)
	if (locale === "es") return es_landing_application_overview_label(inputs)
	if (locale === "it") return it_landing_application_overview_label(inputs)
	if (locale === "nl") return nl_landing_application_overview_label(inputs)
	if (locale === "pl") return pl_landing_application_overview_label(inputs)
	if (locale === "fi") return fi_landing_application_overview_label(inputs)
	if (locale === "da") return da_landing_application_overview_label(inputs)
	if (locale === "sv") return sv_landing_application_overview_label(inputs)
	return en_landing_application_overview_label(inputs)
});